// src/views/pages/NotFound.js
import React from "react";

const NotFound = () => {
  return (
    <div className="flex justify-center items-center h-[400px]">
      <h1 className="text-4xl text-black font-bold">404 - Page Not Found</h1>
    </div>
  );
};

export default NotFound;
